{
  "UI Elements": "UI Elements",
  "Forms & Tables": "Forms & Tables",
  "Pages": "Pages",
  "Charts & Maps": "Charts & Maps",
  "Others": "Others",
  "Typography": "Typography",
  "Cards": "Cards",
  "Basic": "Basic",
  "Advance": "Advance",
  "Widgets": "Widgets",
  "Components": "Components",
  "Alert": "Alert",
  "Close Alert": "Close Alert",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Button",
  "Calendar": "Calendar",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progress Circular",
  "Progress Linear": "Progress Linear",
  "Autocomplete": "Autocomplete",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Date Time Picker",
  "Select": "Select",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Rating",
  "File Input": "File Input",
  "Otp Input": "Otp Input",
  "Form Layout": "Form Layout",
  "Form Validation": "Form Validation",
  "Charts": "Charts",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chartjs",
  "Account Settings": "Account Settings",
  "User Profile": "User Profile",
  "FAQ": "FAQ",
  "Dialog Examples": "Dialog Examples",
  "Pricing": "Pricing",
  "List": "List",
  "Edit": "수정",
  "Nav Levels": "Nav Levels",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Raise Support",
  "Documentation": "Documentation",
  "Dashboards": "Dashboards",
  "Analytics": "Analytics",
  "Apps & Pages": "Apps & Pages",
  "Email": "이메일",
  "Chat": "Chat",
  "Invoice": "Invoice",
  "Preview": "Preview",
  "Add": "등록",
  "User": "사용자",
  "View": "View",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Login": "Login",
  "Register v1": "Register v1",
  "Register v2": "Register v2",
  "Register": "Register",
  "Forget Password v1": "Forget Password v1",
  "Forget Password v2": "Forget Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Forgot Password",
  "Reset Password v1": "Reset Password v1",
  "Reset Password v2": "Reset Password v2",
  "Reset Password": "Reset Password",
  "Miscellaneous": "Miscellaneous",
  "Coming Soon": "Coming Soon",
  "Not Authorized": "Not Authorized",
  "Under Maintenance": "Under Maintenance",
  "Error": "Error",
  "Statistics": "Statistics",
  "Actions": "Actions",
  "Access Control": "Access Control",
  "User Interface": "User Interface",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icons",
  "Chip": "Chip",
  "Dialog": "Dialog",
  "Expansion Panel": "Expansion Panel",
  "Combobox": "Combobox",
  "Textfield": "Textfield",
  "Range Slider": "Range Slider",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Tabs",
  "Form Elements": "Form Elements",
  "Form Layouts": "Form Layouts",
  "Authentication": "Authentication",
  "Page Not Found - 404": "Page Not Found - 404",
  "Not Authorized - 401": "Not Authorized - 401",
  "Server Error - 500": "Server Error - 500",
  "2": "2",
  "Forms": "Forms",
  "Timeline": "Timeline",
  "Disabled Menu": "Disabled Menu",
  "Help Center": "Help Center",
  "Verify Email": "Verify Email",
  "Verify Email v1": "Verify Email v1",
  "Verify Email v2": "Verify Email v2",
  "Two Steps": "Two Steps",
  "Two Steps v1": "Two Steps v1",
  "Two Steps v2": "Two Steps v2",
  "Custom Input": "Custom Input",
  "Extensions": "Extensions",
  "Tour": "Tour",
  "Register Multi-Steps": "Register Multi-Steps",
  "Wizard Examples": "Wizard Examples",
  "Checkout": "Checkout",
  "Create Deal": "Create Deal",
  "Property Listing": "Property Listing",
  "Roles & Permissions": "Roles & Permissions",
  "Roles": "Roles",
  "Simple Table": "Simple Table",
  "Tables": "Tables",
  "Data Table": "Data Table",
  "Permissions": "권한관리",
  "Apps": "Apps",
  "Misc": "Misc",
  "Wizard Pages": "Wizard Pages",
  "Form Wizard": "Form Wizard",
  "Numbered": "Numbered",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editors",
  "Front Pages": "Front Pages",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Payment",
  "Swiper": "Swiper",
  "Product": "Product",
  "Category": "Category",
  "Order": "Order",
  "Details": "Details",
  "Customer": "Customer",
  "Manage Review": "Manage Review",
  "Referrals": "Referrals",
  "Settings": "Settings",
  "Overview": "Overview",
  "My Course": "My Course",
  "Course Details": "Course Details",
  "Academy": "Academy",
  "Logistics": "Logistics",
  "Dashboard": "대시보드",
  "UserAdd": "기관 및 사용자 등록",
  "Fleet": "Fleet",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "Projects": "시험",
  "Project": "시험",
  "Sources": "등록",
  "Site": "기관",
  "IP drug": "IP drug",
  "Sample": "Sample",
  "Template": "Template",
  "Treeview": "Treeview",
  "Html2Pdf": "Html2Pdf",
  "Draggable": "Draggable",
  "Store": "Store",
  "Build": "문서개발",
  "Subjects": "기록",
  "SubjectsV2": "동물(검체) 관리",
  "GuardianSurvey": "보호자 설문",
  "GuardianSurveySms": "문자",
  "Subject": "동물(검체)",
  "Management": "관리",
  "Schedule": "스케쥴",
  "Cycle": "Cycle",
  "Visit": "Visit",
  "CRF Group": "CRF 그룹",
  "CRF Page": "CRF 페이지",
  "Standard": "선정 제외 기준",
  "Random": "무작위 배정표",
  "Label": "라벨",
  "Desc": "설명",
  "Data": "데이터",
  "Review": "Review",
  "Freezing": "Freezing",
  "Freeze": "Freeze",
  "Locking": "Locking",
  "Data set": "Data set",
  "Document": "Document",
  "Audit Trail": "Audit Trail",
  "Management Users": "전체사용자 관리",
  "Users": "사용자",
  "Management Sites": "전체기관 관리",
  "Sites": "수탁기관",
  "Add Site": "기관 등록",
  "loading...": "로딩중... 기다려주세요.",
  "Type": "유형",
  "Description": "시험 설계",
  "Start Date": "시작일",
  "Search": "검색",
  "Add Project": "시험등록",
  "Select a project": "시험을 선택해 주세요.",
  "Project Name": "시험명",
  "Project No": "시험번호",
  "Project Description": "시험 설계",
  "Sponsor": "의뢰사",
  "Phase": "시험단계",
  "ProjectStatus": "프로젝트 상태",
  "Save": "저장",
  "Cancel": "취소",
  "Confirm": "확인",
  "Close": "닫기",
  "Next": "다음",
  "Site ID": "수탁기관 번호",
  "Site Name": "수탁기관",
  "Contract date": "개시일",
  "Phone": "연락처",
  "Address": "주소",
  "Investigator": "시험자",
  "Investigator team": "수탁 기관",
  "Etc": "기타",
  "Expire": "비활성화",
  "User Name": "사용자명",
  "End Date": "종료일",
  "Status": "상태",
  "Assignment": "군배정",
  "Move": "입력",
  "Organization": "소속",
  "Role": "역할",
  "Add User": "사용자 등록",
  "Edit User": "사용자 수정",
  "Select Role": "역할 선택",
  "Select Site": "기관 선택",
  "Subject Name": "동물(검체) 이름",
  "Animal Name": "동물 이름",
  "Subject Number": "식별번호",
  "Species": "종",
  "Breed": "품종",
  "Sex": "성별",
  "Birthday": "생년월일",
  "Add Subject": "동물(검체) 등록",
  "History": "이력",
  "Restore": "복원",
  "Process": "과정",
  "Reason": "사유",
  "Subject History": "동물(검체) 이력",
  "Creator": "작업자",
  "Date/Time": "날짜/시각",
  "eSignature": "전자 서명",
  "Restore Subject": "기록 복원",
  "Delete Subject": "기록 삭제",
  "eSignature_1": "아래의 내용을 확인하신 후 하단 화면에서 사용자 ID와 비밀번호를 입력해주세요.",
  "eSignature_2": "나는 입력한 내용이 정확하게 서술되었다는 점에 동의합니다.",
  "eSignature_2_1": "이 전자 서명은 수기 서명과 동등한 법적 구속력을 가진다는 것을 이해하고 동의합니다.",
  "eSignature_3": "*개인정보 보호를 위해 공용 PC에 아이디/비밀번호를 저장하지 마세요.",
  "Password": "비밀번호",
  "Date of informed consent": "동의서 작성일",
  "Site Subject Number": "식별번호",
  "Chart No": "차트번호",
  "Age": "나이",
  "Add Visit": "방문일 추가",
  "UV": "추가방문",
  "Enrolled Sites": "등록된 기관",
  "Enrolled Subjects": "등록된 동물(검체)",
  "Study Notification": "시험공지사항",
  "Title": "제목",
  "Contents": "내용",
  "AttachedFiles": "첨부파일",
  "Written by": "작성자",
  "Date": "일자",
  "File": "파일",
  "Adverse Events": "이상반응",
  "Unanswered eCRF": "미응답 eCRF",
  "Visit Label": "Visit 라벨",
  "CRF group": "CRF 그룹",
  "Monthly Enrollment Status": "월별 등록 현황",
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "등록된 데이터가 없습니다.",
    "close": "Close",
    "open": "open",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimiter"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "페이지 당 항목 수:",
      "itemsPerPageAll": "전체",
      "pageText": "{0}-{1} / {2}",
      "firstPage": "First Page",
      "prevPage": "Previous Page",
      "nextPage": "Next Page",
      "lastPage": "Last Page"
    },
    "pagination": {
      "ariaLabel": {
        "root": "root",
        "previous": "previous",
        "next": "next",
        "currentPage": "currentPage",
        "page": "page"
      }
    },
    "input": {
      "clear": "clear",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    },
    "dataIterator": {
      "loadingText": "Loading... Please wait"
    }
  }
}
